export const LinkedInDELoginExperimentKey = 'KRK-811-DE';
export const LinkedInCEExceptDELoginExperimentKey = 'KRK-811-CE-except-DE';
export const LinkedInUKLoginExperimentKey = 'KRK-811-UK';
export const linkedInLogin = {
    [LinkedInDELoginExperimentKey]: {
        experimentId: '5766072654102528',
        variantsIds: {
            A: '5484174488895488', // Original
            B: '6610074395738112', // Variation #1
        },
    },
    [LinkedInCEExceptDELoginExperimentKey]: {
        experimentId: '4606741325807616',
        variantsIds: {
            A: '6304264604090368', // Original
            B: '4856189268262912', // Variation #1
        },
    },
    [LinkedInUKLoginExperimentKey]: {
        experimentId: '6398117625462784',
        variantsIds: {
            A: '5649655619387392', // Original
            B: '5086705665966080', // Variation #1
        },
    },
};
//# sourceMappingURL=linkedInLogin.js.map